import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import { request } from '@/api/request';
import Upload from '../../upload/Upload';
import actions from '@/redux/action';
import Utils from '@/utils';
import VideoMuteContentFunction from './children/videoMuteWorkContentFunction/VideoMuteWorkContentFunction';
import VideoMuteFinishFunction from './children/videoMuteWorkFinishFunction/VideoMuteWorkFinishFunction';
import '@/assets/videoMute.less';
import moment from 'moment';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
class VideoMute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoAccept:
        '.mkv,.mov,.mp4,.avi,.wmv,.vob,.webm,.asf,.f4v,.flv,.mpg,.mpeg,.ts,.mxf,.ogv,.swf',
      submitStatus: 'waiting',
      submitting: false,
      processText: '',
    };
    this.cancelWork = false;
  }

  handleVideoMuteObjChange = (videoMuteObj) => {
    this.props.onVideoMuteObjChange(videoMuteObj);
  };

  addFileCallBack = (videoMuteObj) => {
    let flag = Utils.handleVideoEditorTimes('25VM');
    if (flag) {
      return false;
    }
    this.props.onVideoMuteObjChange(videoMuteObj);
    this.handleSubmit(videoMuteObj);
  };

  handleSubmit = async (videoMuteObj) => {
    const startSubmitTime = new Date().valueOf();
    this.cancelWork = false;
    this.setState({ submitting: true });
    if (!videoMuteObj.uploadStatus) {
      this.props.onProcessStepChange(3);
    } else {
      this.props.onProcessStepChange(2);
    }
    if (!videoMuteObj.uploadStatus) {
      const startTime = { ...this.props.startTime };
      startTime.upload = startSubmitTime;
      this.props.onStartTimeChange(startTime);
      this.setState({ processText: 'Uploading' });
      let fileResponse;
      try {
        fileResponse = await this.requestUploadVideoFile(videoMuteObj.fileObj);
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
        }
        this.handleSubmitFail(error);
        return false;
      }
      if (this.cancelWork) {
        this.handleSubmitFail('cancel');
        return false;
      }
      if (fileResponse.code === 200) {
        sentGAEvent({
          category: 'UploadSuccess',
          action: '25VM_UploadSuccess',
          label: 'Null',
        });
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl = fileResponse.data.response_file[0];
          let fileProcessResponse;
          try {
            fileProcessResponse = await Utils.getProgress(
              fileResponseNumber,
              false
            );
          } catch (error) {
            console.log('error', error);
            if (error !== 'cancel') {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadVideo' + '_200_200_' + error,
              });
            }
            this.handleSubmitFail(error);
            return false;
          }
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerSuccess',
          });
          sentGAEvent({
            category: 'mute_add_files',
            action: 'mute_add_files',
            label: `${
              videoMuteObj.name.split('.')[
                videoMuteObj.name.split('.').length - 1
              ]
            }_${(videoMuteObj.size / 1024).toFixed(2)}kb_${
              fileProcessResponse.info[0].wh.split('x')[0]
            }*${fileProcessResponse.info[0].wh.split('x')[1]}`,
          });
          videoMuteObj.videofileurl = fileResponseUrl;
          videoMuteObj.status = 'uploaded';
          videoMuteObj.uploadStatus = true;
          this.props.onVideoMuteObjChange(videoMuteObj);
        }
      } else {
        if (fileResponse.code === 401) {
          Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
          let hostName = window.location.hostname;
          Cookies.remove('access_token', {
            domain: hostName.substring(
              window.location.hostname.indexOf('.'),
              hostName.length
            ),
          });
          Cookies.remove('access_token_expires_in', {
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.replace(
            `${accountList.get('login')}?redirect=${window.location.href}`
          );
        }
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadVideo' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        this.handleSubmitFail();
        return false;
      }
    }
    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    this.setState({ processText: this.props.t('Muting') });
    let workResponse;
    try {
      workResponse = await this.requstVideoMute(videoMuteObj.videofileurl);
    } catch (error) {
      if (error !== 'cancel') {
        sentGAEvent({
          category: 'mute_fail',
          action: 'mute_fail',
          label:
            'splitVideoAudio_none_none_' + this.props.tokenId + '_none_none',
        });
      }
      this.handleSubmitFail(error);
      return false;
    }
    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    if (workResponse.code === 200) {
      if (workResponse.data.result.number) {
        const workResponseNumber = workResponse.data.result.number;
        let progressResponse;
        try {
          sentGAEvent({
            category: 'ProcessStart',
            action: '25VM_ProcessStart',
            label: 'Null',
          });
          progressResponse = await Utils.getProgress(workResponseNumber, false);
          sentGAEvent({
            category: 'ProcessSuccess',
            action: '25VM_ProcessSuccess',
            label: 'Null',
          });
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'mute_fail',
              action: 'mute_fail',
              label: 'splitVideoAudio' + '_200_200_' + error,
            });
          }
          this.handleSubmitFail(error);
          return false;
        }
        this.sentGAOfSubmitSuccess(startSubmitTime);
        const videoMuteAfter = {
          name: moment(new Date().valueOf()).format('YYYYMMDDHHmmss') + '.mp4',
          size: parseFloat(progressResponse.info[0].size),
          downloadurl: progressResponse.info[0].url,
          format: this.state.format,
        };
        this.setState({
          submitting: false,
          submitStatus: 'success',
          videoMuteAfter,
        });

        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onUploadPercentChange(0);
      }
    } else {
      sentGAEvent({
        category: 'mute_fail',
        action: 'mute_fail',
        label:
          'splitVideoAudio' +
          '_200_' +
          workResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          workResponse.msg,
      });
      if (workResponse.code === 402102) {
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '25VM_UpgradePrompShow',
        });
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
        });
        this.props.onVideoMuteObjChange(null);
        this.handleSubmitFail('cancel');
      } else {
        this.handleSubmitFail();
      }
      return false;
    }
  };

  sentGAOfSubmitSuccess = (startTime) => {
    sentGAEvent({
      category: 'mute_success',
      action: 'mute_success',
      label: new Date().valueOf() - startTime + 'ms',
    });
  };

  handleSubmitFail = (error) => {
    if (error !== 'cancel') {
      this.setState({
        submitStatus: 'failed',
      });
    }
    this.setState({ submitting: false });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
  };

  requstVideoMute = (file_url) => {
    const formData = new FormData();
    formData.append('file_url', file_url);
    formData.append('is_mute_video', 1);
    formData.append('is_audio', 0);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`splitVideoAudio`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requestUploadVideoFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    sentGAEvent({
      category: 'UploadStart',
      action: '25VM_UploadStart',
      label: 'Null',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadVideo`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  getRequestData = () => {
    const { resolution, format, level } = this.state;
    let data = {
      format,
      level,
    };
    switch (resolution) {
      case 'original':
        data.resolution = -1;
        break;
      case '240p':
        data.resolution = '320*240';
        break;
      case '360p':
        data.resolution = '480*360';
        break;
      case '480p':
        data.resolution = '640*480';
        break;
      case '720p':
        data.resolution = '1280*720';
        break;
      case '1080p':
        data.resolution = '1920*1080';
        break;
      default:
        break;
    }
    return data;
  };

  cancelProcess = () => {
    if (!this.props.videoMuteObj.uploadStatus) {
      sentGAEvent({
        category: 'Upload',
        action: 'LoadCancel',
        label:
          (this.props.videoMuteObj.fileObj.size / 1024 / 1024).toFixed(2) +
          'm_' +
          (new Date().getTime() - this.props.startTime.upload) / 1000 +
          's',
      });
    }
    this.setState({
      submitting: false,
      submitStatus: 'waiting',
    });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
    this.props.onVideoMuteObjChange(null);
    this.props.onUploadXHRChange(null);
    const xhr = this.props.uploadXHR;
    if (
      xhr &&
      this.props.uploadPercent <
        (this.props.uploadNumber ? this.props.uploadNumber * 100 : 100)
    ) {
      xhr.abort();
    } else {
      if (this.props.fetchAbort) {
        this.props.fetchAbort();
      }
      Utils.cancleProgress();
    }
    this.cancelWork = true;
  };

  render() {
    const { t } = this.props;
    return (
      <div className='work-cont'>
        {this.state.submitStatus === 'waiting' ? (
          <div className='work-hd'>
            <h1 className='container'>{t('HitPaw Online Mute Video')}</h1>
            <p className='container'>
              {t('Fast and easy to remove sound from your video online')}
            </p>
          </div>
        ) : null}
        {!this.props.videoMuteObj ? (
          <Upload
            visible
            accept={this.state.videoAccept}
            addFileCallBack={this.addFileCallBack}
            uploadMaxCount={1}
          />
        ) : this.state.submitStatus === 'waiting' ? (
          <VideoMuteContentFunction
            processText={this.state.processText}
            submitting={this.state.submitting}
            videoMuteObj={this.props.videoMuteObj}
            handleVideoMuteObjChange={this.handleVideoMuteObjChange}
            handleSubmit={this.handleSubmit}
            cancelProcess={this.cancelProcess}
          />
        ) : (
          <VideoMuteFinishFunction
            submitStatus={this.state.submitStatus}
            videoMuteAfter={this.state.videoMuteAfter}
            videoMuteObj={this.props.videoMuteObj}
            handleTryAgain={() => {
              this.setState({ submitStatus: 'waiting' });
              this.props.onVideoMuteObjChange(null);
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  videoMuteObj: state.work.videoMuteObj,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  uploadXHR: state.work.uploadXHR,
  fetchAbort: state.work.fetchAbort,
  startTime: state.work.startTime,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onVideoMuteObjChange: (videoMuteObj) =>
    dispatch(actions.onVideoMuteObjChange(videoMuteObj)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onStartTimeChange: (startTime) =>
    dispatch(actions.onStartTimeChange(startTime)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['videoMute', 'common'])(VideoMute));
